<template>

  <div class="resume">
    <Hero v-bind:image="true" />
    <Bio/>
    <ResumeList/>
  </div>

</template>

<script>

  // @ is an alias to /src
  import Hero from '@/components/Hero.vue'
  import Bio from '@/components/Bio.vue'
  import ResumeList from '@/components/ResumeList.vue'

  export default {
    name: 'resume',
    components: {
      Hero,
      Bio,
      ResumeList
    }
  }

</script>
